/* eslint-disable array-callback-return */
import {
  ChoiceGroup,
  ComboBox,
  DatePicker,
  defaultDatePickerStrings,
  IChoiceGroup,
  IChoiceGroupOption,
  IChoiceGroupOptionProps,
  IComboBox,
  IComboBoxOption,
  Icon,
  Label,
  Pivot,
  Stack,
} from "@fluentui/react";
import { useCallback, useEffect, useImperativeHandle, useRef, useState } from "react";
import { IItemComboBaseDTO } from "../../../Interfaces/base/IBase";
import { Ifilter } from "../../../Interfaces/filter";
import ListaVerificacionService from "../../../services/listaVerificacionService";
import personaServicio from "../../../services/persona/personaServicio";
import {
  formatDate_DDMMYY,
  formatDate_DDMYY_guion,
  formatDate_YYMMDD_comas,
  formatDate_YYMMDD_guion,
} from "../../../utils/helpers/dateHelpers";
import { _initialFilter } from "../../../utils/helpers/helpers";
import COLORES from "../../../utils/theme/colores";
import themeBase from "../../../utils/theme/themeBase";
import { ComboBoxIDS } from "../../../components/generic/ComboBoxIDS";
import { useComboModelos } from "../../../hooks/combosHooks/useComboModelos";
import { IComboBoxOptionPersonalizado } from "../../iperc/historial/AdminHistorialIperc/reporte/ReporteGeneralIperc";

function FilterMantenimiento({ childToParent, formData, isOpen, pivot, /* filterAvanzado, setFilterAvanzado, */ limpiarFiltros }) {
  /**Fechas de filtro */
  const [modeloEquipos, setModeloEquipos] = useState<IItemComboBaseDTO[]>([]);
  const [tipoEquipo, setTipoEquipo] = useState<IItemComboBaseDTO[]>([]);
  const [equipos, setEquipos] = useState<IItemComboBaseDTO[]>([]);
  const [SupervisoresCombo, setSupervisoresCombo] = useState<
    IComboBoxOptionPersonalizado[]
  >([]);
  const comboBoxRefSupervisores = useRef<IComboBox>(null);
  const [Search, setSearch] = useState("");
  const controllerRef = useRef<AbortController>(new AbortController());
  const [selectedSupervisor, setSelectedSupervisor] = useState<string>("");

  const [fechaInicio, setFechaInicio] = useState<Date | undefined>(undefined);
  const [fechaFin, setFechaFin] = useState<Date | undefined>(undefined);
  const [estados, setEstados] = useState<IItemComboBaseDTO[]>([]);

  /**FILTRO MODELOS */
  const [filterModelos, setFilterModelos] = useState<Ifilter>({
    skip: 0,
    take: 100,
    search: "",
  });
  const [filterEquipos, setFilterEquipos] = useState<Ifilter>({
    skip: 0,
    take: 100,
    search: "",
  });
  const [filterTipoEquipo, setFilterTipoEquipo] =
    useState<Ifilter>(_initialFilter);
/* 
  const [filterAvanzado, setFilterAvanzado] =
    useState<IFilterChecklistMantenimiento>(); */
  const {
    dataComboModelos,
    onClickComboModelos,
    _onkeyUpSearchDispositivo,
    comboBoxRefModelos,
  } = useComboModelos();

  useEffect(() => {
    if (isOpen) {
      setFilterAvanzado({ ...formData });
      setSelectedSupervisor(formData.estadoId);
      ComboSupervisores();
      dataEstados();
      dataEquipos();
      dataTipoEquipos();
    }
  }, [isOpen]);

  useEffect(() => {
    if (fechaInicio) {
      if (fechaFin && fechaFin < (fechaInicio as Date)) {
        setFechaFin(fechaInicio);
      }

      setFilterAvanzado({
        ...filterAvanzado,
        // fecha: formatDate_DDMMYY(fechaInicio),
        fecha: formatDate_YYMMDD_comas(fechaInicio),
      });
      childToParent({
        ...filterAvanzado,
        // fecha: formatDate_DDMMYY(fechaInicio),
        fecha: formatDate_YYMMDD_comas(fechaInicio),
      });
    }
  }, [fechaInicio]);

  useEffect(() => {
    if (fechaInicio) {
      setFilterAvanzado({
        ...filterAvanzado,
        // fechaFin: formatDate_DDMMYY(fechaFin),
        fechaFin: formatDate_YYMMDD_comas(fechaFin),
      });
      childToParent({
        ...filterAvanzado,
        // fechaFin: formatDate_DDMMYY(fechaFin),
        fechaFin: formatDate_YYMMDD_comas(fechaFin),
      });
    }
  }, [fechaFin]);

  const _onChangeTipoEquipo = (
    event: React.FormEvent<IComboBox>,
    option?: IComboBoxOption,
    index?: number,
    value?: string
  ) => {
    if (event != undefined) {
      if (option != undefined) {
        setFilterAvanzado({
          ...filterAvanzado,
          tipoEquipoId: option.key.toString(),
        });
        childToParent({
          ...filterAvanzado,
          tipoEquipoId: option.key.toString(),
        });
      }
    }
  };
  const _onChangeEqipos = (
    event: React.FormEvent<IComboBox>,
    option?: IComboBoxOption,
    index?: number,
    value?: string
  ) => {
    if (event != undefined) {
      if (option != undefined) {
        setFilterAvanzado({
          ...filterAvanzado,
          equipoId: option.key.toString(),
        });
        childToParent({
          ...filterAvanzado,
          equipoId: option.key.toString(),
        });
      }
    }
  };
  const _onChangeModelos = (
    event: React.FormEvent<IComboBox>,
    option?: IComboBoxOption,
    index?: number,
    value?: string
  ) => {
    if (event != undefined) {
      if (option != undefined) {
        setFilterAvanzado({
          ...filterAvanzado,
          equipoModeloId: option.key.toString(),
        });
        childToParent({
          ...filterAvanzado,
          equipoModeloId: option.key.toString(),
        });
      }
    }
  };
  const _onChangeSupervisor = (
    event: React.FormEvent<IComboBox>,
    option?: IComboBoxOption,
    index?: number,
    value?: string
  ) => {
    if (event !== undefined) {
      if (option !== undefined) {
        console.log(option.key);
        setFilterAvanzado({
          ...filterAvanzado,
          supervisorId: option.key.toString(),
        });
        childToParent({
          ...filterAvanzado,
          supervisorId: option.key.toString(),
        });
      }
    }
  };

  const _onChangeEstados = (
    ev?: React.FormEvent<HTMLElement | IChoiceGroup>,
    option?: IChoiceGroupOption
  ) => {
    if (ev != undefined) {
      if (option != undefined) {
        console.log(option.key);
        setFilterAvanzado({
          ...filterAvanzado,
          estadoId: option.key.toString(),
        });
        childToParent({
          ...filterAvanzado,
          estadoId: option.key.toString(),
        });
        setSelectedSupervisor(option.key.toString());
      }
    }
  };

  const dataModelos = () => {
    ListaVerificacionService.listaModeloEquipo(filterModelos)
      .then((res) => {
        // console.log(res.data.data)
        var d = res.data.data;
        var t: IItemComboBaseDTO[] = [];
        d.map((x) => {
          t.push({ key: x.equipoModeloId, text: x.equipo });
        });
        setModeloEquipos(t);
      })
      .catch((e: Error) => {
        alert(e);
      });
  };
  const dataEquipos = () => {
    ListaVerificacionService.listaEquipos(filterEquipos)
      .then((res) => {
        // console.log(res.data)
        setEquipos(res.data);
      })
      .catch((e) => {
        alert(e);
      });
  };
  const dataTipoEquipos = () => {
    ListaVerificacionService.listaTipoEquipos(filterTipoEquipo)
      .then((res) => {
        // console.log(res.data)
        setTipoEquipo(res.data);
      })
      .catch((e) => {
        alert(e);
      });
  };
  const dataEstados = () => {
    ListaVerificacionService.listaEstados()
      .then((res) => {
        // console.log(res.data)
        setEstados(res.data);
      })
      .catch((e) => {
        alert(e);
      });
  };

  const ComboSupervisores = (search: string = "") => {
    controllerRef.current.abort();
    const newController = new AbortController();
    controllerRef.current = newController;
    personaServicio
      .getSupervisoresCombo(search, newController)
      .then((arg) => {
        let d: any[] = arg.data;
        // let op: IComboBoxOption[] = [];
        // d.map((x) => {
        //   op.push({
        //     key: x.supervisorId,
        //     text: x.persona,
        //   });
        // });
        setSupervisoresCombo(d);
      })
      .catch((e: Error) => {
        console.log(e.message);
      });
  };

  const _onkeyUpSearchSupervisores = (
    event: React.KeyboardEvent<IComboBox>
  ) => {
    if (event.code === "Escape") {
      comboBoxRefSupervisores.current?.focus(false);
      setSearch("");
    } else {
      _openOptionSupervisores();
      let { value } = event?.target as HTMLInputElement;
      setSearch(value);
    }
  };

  const _openOptionSupervisores = useCallback(
    () => comboBoxRefSupervisores.current?.focus(true),
    []
  );
  const onClickComboSupevisores = () =>
    comboBoxRefSupervisores.current?.focus(true);

  useEffect(() => {
    ComboSupervisores(Search);
  }, [Search]);

  const limpiarFiltrosPanel = () => {
    setFilterAvanzado({});
    setFechaInicio(undefined);
    setFechaFin(undefined);
    setSelectedSupervisor("");
  }

  const [filterAvanzado, setFilterAvanzado] =
    useState<IFilterChecklistMantenimiento>();

  useEffect(() => {
    if (limpiarFiltros) {
      limpiarFiltrosPanel();
    }
  }, [limpiarFiltros]);

  return (
    <div className="ms-Grid" dir="ltr">
      <br />
      <Stack tokens={themeBase.StackTokens15}>
        <div className="ms-Grid-row">
          <div className="ms-Grid-col ms-sm12 ms-md12 ms-lg6">
            <DatePicker
              label="Fecha Inicio"
              placeholder="dd/mm/yyyy"
              ariaLabel="Seleccione una fecha"
              onSelectDate={setFechaInicio as (date?: any) => void}
              formatDate={formatDate_DDMMYY}
              strings={defaultDatePickerStrings}
              value={fechaInicio}
              maxDate={new Date()}
              borderless
              style={{ borderBottom: `solid 1px ${COLORES.Bases.primary}` }}
            />
          </div>
          <div className="ms-Grid-col ms-sm12 ms-md12 ms-lg6">
            <DatePicker
              label="Fecha Fin"
              placeholder="dd/mm/yyyy"
              ariaLabel="Seleccione una fecha"
              onSelectDate={setFechaFin as (date?: any) => void}
              formatDate={formatDate_DDMMYY}
              strings={defaultDatePickerStrings}
              value={fechaFin}
              minDate={fechaInicio}
              maxDate={new Date()}
              borderless
              style={{ borderBottom: "solid 1px blue" }}
              disabled={fechaInicio != undefined ? false : true}
            />
          </div>
        </div>
        <div className="ms-Grid-row">
          <div className="ms-Grid-col ms-sm12 ms-md12 ms-lg12">
            <ComboBox
              label="Supervisor"
              text={filterAvanzado?.supervisorId ? SupervisoresCombo.find((x) => x.key === filterAvanzado?.supervisorId)?.text : ""}
              componentRef={comboBoxRefSupervisores}
              onKeyUp={_onkeyUpSearchSupervisores}
              options={SupervisoresCombo}
              allowFreeform
              onChange={_onChangeSupervisor}
              selectedKey={filterAvanzado?.supervisorId}
              onClick={onClickComboSupevisores}
              onRenderOption={(option) => (
                <>
                  {option && (
                    <div>
                      <span>{option?.text}</span>
                      <br />
                      <span
                        style={{
                          paddingBottom: "0.9px",
                          color: "#777",
                          fontSize: "0.7rem",
                        }}
                      ></span>
                    </div>
                  )}
                </>
              )}
              // disabled
              useComboBoxAsMenuWidth
              styles={{ optionsContainer: { height: 200 } }}
            />
          </div>
        </div>
        {pivot.toString() === "2" && (
          <div className="ms-Grid-row">
            <div className="ms-Grid-col ms-sm12 ms-md12 ms-lg6">
              <Label id="labelElement">
                <Stack horizontal verticalAlign="center">
                  <span>Estados&nbsp;&nbsp;</span>
                  <Icon iconName="Filter" />
                </Stack>
              </Label>
              <ChoiceGroup
                selectedKey={selectedSupervisor}
                options={estados}
                onChange={_onChangeEstados}
                ariaLabelledBy="labelElement"
              />
            </div>
          </div>
        )}
        <div className="ms-Grid-row">
          <div className="ms-Grid-col ms-sm6 ms-lg12">
            <ComboBox
              useComboBoxAsMenuWidth
              allowFreeform
              text={filterAvanzado?.tipoEquipoId ? tipoEquipo.find((x) => x.key === filterAvanzado?.tipoEquipoId)?.text : ""}
              calloutProps={{ directionalHintFixed: true }}
              scrollSelectedToTop
              autoComplete="off"
              label="Tipo Equipo"
              options={tipoEquipo}
              onChange={_onChangeTipoEquipo}
              selectedKey={filterAvanzado ? filterAvanzado.tipoEquipoId : ""}
            />
          </div>
        </div>
        <div className="ms-Grid-row">
          <div className="ms-Grid-col ms-sm6 ms-lg6">
            <ComboBoxIDS
              title="Modelos de Equipos:"
              text={filterAvanzado?.equipoModeloId
                ? dataComboModelos.find((x) => x.key === filterAvanzado?.equipoModeloId)?.text
                : ""}
              componentRef={comboBoxRefModelos}
              KeyUp={_onkeyUpSearchDispositivo}
              onClick={onClickComboModelos}
              options={dataComboModelos}
              onChange={_onChangeModelos}
            />

            {/* <ComboBox
              useComboBoxAsMenuWidth
              allowFreeform
              calloutProps={{ directionalHintFixed: true }}
              scrollSelectedToTop
              autoComplete="off"
              label="Equipo Modelo"
              options={modeloEquipos}
              onChange={_onChangeModelos}
              selectedKey={filterAvanzado ? filterAvanzado.equipoModeloId : ""}
            /> */}
          </div>
          <div className="ms-Grid-col ms-sm6 ms-lg6">
            <ComboBox
              text={filterAvanzado?.equipoId ? equipos.find((x) => x.key === filterAvanzado?.equipoId)?.text : ""}
              useComboBoxAsMenuWidth
              allowFreeform
              calloutProps={{ directionalHintFixed: true }}
              scrollSelectedToTop
              autoComplete="off"
              label="Equipo"
              options={equipos}
              onChange={_onChangeEqipos}
              selectedKey={filterAvanzado ? filterAvanzado.equipoId : ""}
            />
          </div>
        </div>
      </Stack>
    </div>
  );
}

export default FilterMantenimiento;

export interface IFilterChecklistMantenimiento {
  equipoModeloId?: string | null;
  tipoEquipoId?: string | null;
  equipoId?: string | null;
  estadoId?: string | null;
  fecha?: string | null;
  fechaFin?: string | null;
  SoloCriticas?: boolean;
  supervisorId?: string | null;
}
